var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[(!_vm.aiAssistSelectingData)?_c('UploadProductSectionWidget'):_vm._e(),_c('MainSection',{attrs:{"ai-assist-selecting-data":_vm.aiAssistSelectingData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }